<swiper-container space-between="0" loop="false" slides-per-view="1" pagination="true" navigation="true" speed="400">
  <swiper-slide lazy="true" *ngFor="let imagem of imagens">
    <img [src]="imagem.link_thumb" alt="imagem.title" loading="lazy" (click)="abreImovel()" />
  </swiper-slide>
</swiper-container>